import {Component} from '@angular/core';

@Component({
    template: '<div>NotAuthorizedComponent</div>',
    standalone: false
})
export class NotAuthorizedComponent {

}
